import type { GameServer } from '@agent8-dev/gameserver';
import type { V8Client } from './types';

/**
 * GameServer 인스턴스를 단순 V8Client interface 로 wrap.
 * Hono routes 등 RPC 호출만 필요한 곳에서 사용.
 */
export function asV8Client(server: GameServer): V8Client {
  return {
    async call<T = unknown>(name: string, ...args: unknown[]): Promise<T> {
      return (await server.remoteFunction(name, args)) as T;
    },
    isHealthy(): boolean {
      return server.connected;
    },
  };
}
